import React from "react";
import { useBlocNext } from "@blac/react";
import styled from "@emotion/styled";
import Track from "../Track/Track";
import TaskManagementBloc, {
  TaskKey
} from "src/state/TaskManagementBloc/TaskManagementBloc";
import LabStatusOverviewCubit, {
  type GroupedCategory
} from "./LabStatusOverviewCubit";
import LabCategoryToggle, {
  type LabDisplayMode
} from "../LabCategoryToggle/LabCategoryToggle";
import CollectionTitle from "../StyledComponents/CollectionTitle";

export type { LabDisplayMode };

const CategoryContainer = styled.div`
  label: LabCategoryContainer;
  display: flex;
  flex-direction: column;
  width: min(100%, 400px);
  background: var(--color-white);
  border-radius: 0.8rem;
  overflow: hidden;
  box-shadow: var(--light-shadow);
  text-align: left;
`;

interface LabStatusOverviewProps {
  displayMode?: LabDisplayMode;
  groupedCategories: GroupedCategory[];
}

const LabStatusOverview: React.FC<LabStatusOverviewProps> = ({
  displayMode = "status",
  groupedCategories
}) => {
  const [, { labsTrackingData }] = useBlocNext(LabStatusOverviewCubit);

  const [, { getTask }] = useBlocNext(TaskManagementBloc, {
    dependencySelector: (state) => [state.tasks]
  });

  const completeLabsTask = getTask(TaskKey.COMPLETE_INITIAL_LAB_ORDER);
  const taskStatus = completeLabsTask?.status;

  const trackingData = {
    taskStatus: taskStatus ?? "unknown",
    displayMode,
    ...labsTrackingData
  };

  if (groupedCategories.length === 0) {
    return null;
  }

  return (
    <>
      <Track event="Lab Status Overview Shown" data={trackingData} />

      <CollectionTitle>Recommended Lab panels</CollectionTitle>
      <CategoryContainer>
        {groupedCategories.map((category) => (
          <LabCategoryToggle
            key={category.category}
            category={category}
            displayMode={displayMode}
          />
        ))}
      </CategoryContainer>
      <div style={{ height: "3rem" }} aria-hidden />
    </>
  );
};

export default LabStatusOverview;
